// grabbed from spyder and modified
export const getPlanYearLookupCodeFromOrgPlanYear = (
  planYearStartsOn: Date,
  planYearEndsOn: Date
) => {
  const NEXT_PY_TYPE = 'next';
  const CURRENT_PY_TYPE = 'current';
  const PREVIOUS_PY_TYPE = 'previous';

  const today = new Date();
  const pyStartDate = new Date(planYearStartsOn);
  const pyEndDate = new Date(planYearEndsOn);

  if (pyStartDate > today) {
    return NEXT_PY_TYPE;
  } else if (pyStartDate <= today && pyEndDate >= today) {
    return CURRENT_PY_TYPE;
  } else if (pyStartDate < today) {
    return PREVIOUS_PY_TYPE;
  }

  return null;
};
